import React, { useState, useEffect } from "react";
import moment from "moment";

const AdvertiserDetailsTransactionsReportController = props => {
  const { signedURL, advertiser } = props;
  const [reportDataSummary, setReportData] = useState({
    byDates: [],
    transactions: [],
    summary: {
      customers: 0,
      impressions: 0,
      revenue: 0,
      transactions: 0,
      roas: 0,
      spend: 0,
    },
  });
  const [reportDataRawSummary, setReportRawData] = useState();
  const [reportDataSummaryLoading, setReportLoading] = useState(true);
  const [reporDataSummarytError, setReportError] = useState();

  useEffect(() => {
    if (signedURL) {
      const s3UrlSummary = new URL(signedURL.getSignedURL);
      fetch(s3UrlSummary).then(async response => {
        if (response && response.ok) {
          try {
            await response.json().then(json => {
              setReportData(json);
              setReportRawData(json);
              setReportLoading(false);
            });
          } catch (err) {
            console.log(err);
            setReportError(err);
            setReportLoading(false);
          }
        } else {
          setReportLoading(false);
        }
      });
    }
  }, [signedURL]);

  const changeDatePicker = dates => {
    const datePickerStartDate = dates[0].format("YYYY-MM-DD");
    const datePickerEndDate = dates[1].format("YYYY-MM-DD");

    const { byDates, transactions } = reportDataRawSummary;

    const newByDates = byDates.filter(
      date =>
        moment(date.date).isSameOrBefore(datePickerEndDate) &&
        moment(date.date).isSameOrAfter(datePickerStartDate)
    );

    const newTransactions = transactions.filter(
      transaction =>
        moment(transaction.transaction).isSameOrAfter(datePickerStartDate) &&
        moment(transaction.transaction).isSameOrBefore(datePickerEndDate)
    );

    let summary = {
      customers: 0,
      impressions: 0,
      revenue: 0,
      transactions: 0,
    };

    const uniqueIPS = [];
    const uniqueCookies = [];
    const uniqueDeviceFingerprints = [];
    const uniqueFingerprints = [];

    newTransactions.forEach(transaction => {
      summary.revenue += parseFloat(transaction.transactionTotal);
      summary.impressions += parseFloat(transaction.totalImpressions);
      summary.transactions += 1;

      const { attributionMethod } = transaction;
      if (attributionMethod && attributionMethod.COOKIE) {
        if (!uniqueCookies.includes(attributionMethod.COOKIE)) {
          uniqueCookies.push(attributionMethod.COOKIE);
        }
      }
      if (attributionMethod && attributionMethod.FINGERPRINT) {
        if (!uniqueFingerprints.includes(attributionMethod.FINGERPRINT)) {
          uniqueFingerprints.push(attributionMethod.FINGERPRINT);
        }
      }

      if (attributionMethod && attributionMethod.DEVICE_FINGERPRINT) {
        if (
          !uniqueDeviceFingerprints.includes(
            attributionMethod.DEVICE_FINGERPRINT
          )
        ) {
          uniqueDeviceFingerprints.push(attributionMethod.DEVICE_FINGERPRINT);
        }
      }
      if (attributionMethod && attributionMethod.IP) {
        if (!uniqueIPS.includes(attributionMethod.IP)) {
          uniqueIPS.push(attributionMethod.IP);
        }
      }
    });

    setReportData({
      byDates: newByDates,
      transactions: newTransactions,
      summary: {
        ...summary,
        customers:
          uniqueCookies.length +
          uniqueFingerprints.length +
          uniqueIPS.length +
          uniqueDeviceFingerprints.length,
      },
    });
  };

  return React.cloneElement(props.children, {
    ...props.children.props,
    reportDataSummary,
    reportDataSummaryLoading,
    reporDataSummarytError,
    advertiser,
    changeDatePicker,
  });
};

export default AdvertiserDetailsTransactionsReportController;
